export namespace Constants
{
    const NAME:string = "zaplicacion";
}



// WEBPACK FOOTER //
// ./src/modules/zaplicacion/constants.ts